import CaseStudyCard from "../../reusables/CaseStudyCard";
import kcg from "../../../assets/images/case-studies/kcg.jpg";

const KCGCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={kcg}
      client="Kampala City Grammar School"
      solution="Website Design"
      title="A leading nursery & primary school wanted an engaging website"
      subtitle="Kampala City Grammar School wanted their website done in 3 days so they can launch it to parents on Visitation day"
      link="https://kampalacitygramarschool.com"
    >
      <li>
        ✔︎ <span>Fast delivery</span>
      </li>

      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Website Management</span>
      </li>
      <li>
        ✔︎ <span>Ongoing Support</span>
      </li>
      <li>
        ✔︎ <span>Search Engine Optimization</span>
      </li>
    </CaseStudyCard>
  );
};

export default KCGCaseStudyCard;
